<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :show-close="false"
    @close="dialogClose"
  >
    <img
      class="close-img"
      src="@/assets/img/images/icon/close-icon.png"
      @click="dialogVisible = false"
    />
    <p class="p1">{{ title }}{{ $t("tipsVal.phone") }}</p>
    <el-form
      class="mt20"
      :model="bindData"
      :rules="rules"
      ref="ruleFormPhoneBind"
    >
      <el-form-item :label="$t('login.input_phone1')" prop="phoneNum">
        <!-- <el-input
          v-model="bindData.phone"
           :placeholder="$t('tipsVal.inputPlaceholder')"
          @change="phoneNumUpdate"
        /> -->
        <div style="width: 100%">
          <vue-phone-number-input
            v-model="bindData.phone"
            :show-code-on-list="true"
            :no-flags="true"
            valid-color="transparent"
            :translations="translations"
            @phone-number-blur="phoneNumBlur"
            @update="phoneNumUpdate"
            :preferred-countries="['CN']"
          />
        </div>
      </el-form-item>
      <el-form-item :label="$t('google_bind.phone_code')" prop="phoneCode">
        <el-input
          v-model="bindData.phoneCode"
          :placeholder="$t('tipsVal.inputPlaceholder')"
        >
          <template slot="append">
            <span
              v-if="!phoneCodeStatus.hasSend"
              class="send-code-btn"
              @click="hasSendPhoneCode"
            >
              {{ $t("set_trade_password.getCode") }}</span
            >
            <span v-else>{{ phoneCodeStatus.times }}</span>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('google_bind.email_code')" prop="emailCode">
        <el-input
          v-model="bindData.emailCode"
          :placeholder="$t('tipsVal.inputPlaceholder')"
        >
          <template slot="append">
            <span
              v-if="!emailCodeStatus.hasSend"
              class="send-code-btn"
              @click="hasSendEmailCode"
            >
              {{ $t("set_trade_password.getCode") }}</span
            >
            <span v-else>{{ emailCodeStatus.times }}</span>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item
        v-if="user.googleSecurity === 1"
        :label="$t('googleBind.google_code')"
        prop="googleCode"
      >
        <el-input
          v-model="bindData.googleCode"
          maxlength="10"
          :placeholder="$t('email_bind.code_placeholder')"
        />
      </el-form-item>
    </el-form>
    <div class="btn-box">
      <div class="btn2" @click="submit">{{ $t("buy_box.confirm") }}</div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      title: this.$t("receipt_money.edit"),
      dialogVisible: false,

      phoneValidateMes: {
        show: false,
        mes: "",
      },
      translations: {
        phoneNumberLabel: this.$t("tipsVal.inputPlaceholder"),
      },
      bindData: {
        bindType: "phone",
        email: "",
        phone: "",
        phoneToken: "",
        phoneCode: "",
        emailToken: "",
        emailCode: "",
        googleCode: "",
      },
      phoneCodeSend: {
        email: "",
        phone: "",
        serviceName: "bind",
        verifyType: "phone",
      },
      phoneCodeStatus: {
        hasSend: false,
        times: 60,
      },
      emailCodeSend: {
        email: "",
        phone: "",
        serviceName: "bind",
        verifyType: "email",
      },
      emailCodeStatus: {
        hasSend: false,
        times: 60,
      },
      rules: {
        phoneCode: [
          {
            required: true,
            message: this.$t("validate.mes_code_require"),
            trigger: "blur",
          },
        ],
        emailCode: [
          {
            required: true,
            message: this.$t("validate.email_code_require"),
            trigger: "blur",
          },
        ],
        googleCode: [
          {
            required: true,
            message: this.$t("validate.google_code_require"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
  },
  methods: {
    phoneNumBlur() {
      if (!this.bindData.phone.trim()) {
        this.phoneValidateMes.mes = this.$t("validate.phone_require");
        this.phoneValidateMes.show = true;
      } else {
        this.phoneValidateMes.show = false;
      }
    },
    phoneNumUpdate(numObj) {
      if (numObj.isValid) {
        this.phoneCodeSend.phone = this.bindData.phone = numObj.nationalNumber;
      }
    },
    hasSendPhoneCode() {
      this.phoneNumBlur();
      if (this.phoneValidateMes.show) {
        return false;
      }
      this.phoneCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.phoneCodeStatus.times <= 0) {
          this.phoneCodeStatus.hasSend = false;
          this.phoneCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.phoneCodeStatus.times--;
        }
      }, 1000);
      this.$axios
        .post("/user/sendSecurityCode", this.phoneCodeSend)
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.bindData.phoneToken = res.data.data.token;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    hasSendEmailCode() {
      this.emailCodeSend.email = this.bindData.email;
      this.emailCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.emailCodeStatus.times <= 0) {
          this.emailCodeStatus.hasSend = false;
          this.emailCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.emailCodeStatus.times--;
        }
      }, 1000);
      this.$axios
        .post("/sendCode/send", { verifyType: "email", serviceName: "bind" })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.bindData.emailToken = res.data.data.token;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    submit() {
      this.phoneNumBlur();
      if (this.phoneValidateMes.show) {
        return false;
      } else {
        let ref = this.$refs.ruleFormPhoneBind;
        ref.validate((valid) => {
          if (!valid) {
            return false;
          } else {
            this.$axios
              .post("/user/bindSecurity", this.bindData)
              .then((res) => {
                if (res.data.code === this.errorCode.ok) {
                  this.elMessage("success", this.$t("phone_bind.success"));
                  this.$store.dispatch("actions_getUserInfo").then((res) => {
                    this.dialogVisible = false;
                  });
                } else {
                  this.elMessage("error", res.data.msg);
                }
              });
          }
        });
      }
    },
    dialogClose() {
      this.bindData.phone = "";
      this.$refs.ruleFormPhoneBind.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  width: 540px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 32px 30px;
  }
  .el-form-item__label {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }

  .el-input__suffix,
  .el-input__suffix-inner {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-input-group--append {
    gap: 16px;
    display: flex;
  }
  .el-input__inner {
    height: 60px;
    border-radius: 8px 8px 8px 8px;
  }
  .el-input-group__append {
    cursor: pointer;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #4063ff;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #4063ff;
    padding: 0 24px;
    width: auto;
    display: flex;
    align-items: center;
  }
  .el-form-item {
    margin-bottom: 8px;
  }
}
.mt8 {
  margin-top: 8px;
}
.p1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 36px;
  color: #333333;
}
.p2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.p3 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
}
.sp1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
}
.sp2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 32px;
  color: #4063ff;
}
.box1 {
  width: 480px;
  height: 160px;
  overflow: hidden;
  padding-left: 20px;
  background: #ffffff;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 12px 12px 12px 12px;
  background-image: url(~@/assets/img/images/member-bj.png);
}
.close-img {
  width: 14px;
  height: 14px;
  top: 20px;
  right: 20px;
  cursor: pointer;
  position: absolute;
}
.btn-box {
  gap: 10px;
  display: flex;
  margin-top: 32px;
  .btn1 {
    flex: 1;
    cursor: pointer;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #4063ff;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #4063ff;
  }
  .btn2 {
    flex: 1;
    height: 48px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    background: #3370ff;
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #ffffff;
  }
}

/deep/ .vue-phone-number-input {
  width: 100%;
  border-radius: 8px 8px 8px 8px;
  background-color: rgba(214, 216, 219, 0.3);
  .vue-input-ui {
    height: 60px !important;
    line-height: 3.75rem !important;
  }
  .country-selector-toggle {
    top: calc(50% - 30px) !important;
  }
  .input-country-selector {
    height: 60px !important;
    line-height: 3.75rem !important;
  }
  #VuePhoneNumberInput_country_selector {
    font-size: 14px;
    border: none !important;
    line-height: 3.75rem !important;
  }
  #VuePhoneNumberInput_phone_number {
    font-size: 14px;
    border: none !important;
    line-height: 3.75rem !important;
  }
}
</style>
